import React, { FC } from "react";
import Container from "@material-ui/core/Container";
import { User } from "../types";
import { UserAccountProvider } from "./context";
import Content from "./Content";

export interface UserAccountProps {
  user: User;
  onUpdate: Function;
}

const UserAccount: FC<UserAccountProps> = React.memo(({ user, onUpdate }) => {
  return (
    <UserAccountProvider user={user} onUpdate={onUpdate}>
      <Container maxWidth={"lg"}>
        <Content />
      </Container>
    </UserAccountProvider>
  );
});

export default UserAccount;
